import React, { useMemo } from "react";
import { RouteGuard } from "./RouteGuard";

interface PublicRouteProps {
  children: React.ReactNode;
}

/**
 * Route protection for public pages (like landing page)
 * Only allows access if user is NOT authenticated
 * Redirects authenticated users to appropriate page based on their status
 */
export const PublicRoute: React.FC<PublicRouteProps> = ({ children }) => {
  const config = useMemo(() => ({
    requireUnauth: true,
    redirectTo: (user: any) => {
      const isNewUser = user?.is_new_user || false;
      return isNewUser ? '/onboarding/personal-details' : '/home';
    },
  }), []);

  return (
    <RouteGuard config={config}>
      {children}
    </RouteGuard>
  );
};

